/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, type CSSProperties } from "react";
import { useMediaQuery } from "react-responsive";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { getUser, getCompany, listCompanies, isJobRoleAccessEnabled, isOrganizationProfileEnabled } from "../utils/api";
import { useAuthData, getAuthData, signOut } from "../utils/auth";

import { CompanySelection } from "../features/organization/Modals";

import logo from "../images/intertru.svg";
import classNames from "classnames";
import { useAppDispatch, useAppSelector } from '../redux/store';
import { fetchCognitoUser, selectCognitoUser } from '../redux/reducers/userSlice';
import { styles } from "./Header.styles";

export default function Header(props) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate();
  const location = useLocation();
  const [isJobRoleFeatureEnabled, setIsJobRoleFeatureEnabled] = useState(false);
  const [isOrgProfileFeatureEnabled, setIsOrgProfileFeatureEnabled] = useState(false)
  
  const paths = {
    dashboard: "Interviews",
    analytics: "Analytics",
    customers: "Customers",
    users: "Users",
    customer: "Customers",
    user: "Users",
    interview: "Interviews",
    summary: "Interviews",
    jobroles: "JobRoles",
    jobrole: "JobRole",
    testing: "Testing",
  };

  const path = window.location.pathname;
  // const p = path.substring(7, path.length - 1);
  const p = path.split("/").slice(-1)[0];
  const isSummaryPage = path.split("/").slice(2)[0] === "summary";
  // lg breakpoint
  const isMobile = useMediaQuery({ query: "(max-width: 991px)" });
  const authData = useAppSelector((state)=>selectCognitoUser(state))
  const { groups, email } = authData ?? { email: null, groups: null };
  let isAdmin = false;
  if (groups && groups.includes("Admin")) isAdmin = true;

  const featureFlagsConfig = async () => {
    let res = await isJobRoleAccessEnabled(email);
    setIsJobRoleFeatureEnabled(res.isFeatureEnabled);
    res = await isOrganizationProfileEnabled(email);
    setIsOrgProfileFeatureEnabled(res.isFeatureEnabled);
  }
  
  useEffect(() => {
    featureFlagsConfig();
  }, [email]);

  const getCognitoUser = async () => {
    dispatch(fetchCognitoUser({getUser: true, getAttr: true, getCogGroups: true }))
  }

  useEffect(()=>{
     getCognitoUser();
  },[email])

  if (!groups || !groups.length) {
	  return <div />
  }

  return (
    <>
      <div style={styles.headerWrapper}>
        <div className="rounded-b-[24px] bg-top bg-cover p-[8px]">
          <div className="flex justify-between mt-[5px] h-[51px] relative">
            <div
              style={styles.logo}
              onClick={() => navigate("/admin/dashboard")}
            >
              <img style={styles.logoImage} src={logo as unknown as string} alt="intertru-text" />
            </div>
            <div style={{position: "absolute", height: 51, marginLeft: 160, display: "flex", justifyContent: "space-between"}}>
              <HeaderLink
                navigate={navigate}
                link="/admin/dashboard"
                text="Interviews"
                selected={paths[p] === "Interviews"}
              />
              {isJobRoleFeatureEnabled === true && (
                <HeaderLink
                link="/admin/jobroles"
                text="Roles"
                selected={paths[p] === "JobRoles" || paths[p] === "JobRole"}
              />
              )}
               
              <HeaderLink
                link="/admin/users"
                text="Users"
                selected={paths[p] === "Users"}
              />
              {isAdmin && (
                <HeaderLink
                  navigate={navigate}
                  link="/admin/customers"
                  text="Customers"
                  selected={paths[p] === "Customers"}
                />
              )}
              {isAdmin && isSummaryPage && (
                <HeaderLink
                  navigate={navigate}
                  link={`/admin/testing/${p}`}
                  text="Testing"
                />
              )}
            </div>
            <div className={'font-bold text-[#021A24]'} style={{display: "flex", gap: 10, justifyContent:"space-between"}}>
              <CompanyDropdown 
                isJobRoleFeatureEnabled={isJobRoleFeatureEnabled}
                isOrgProfileFeatureEnabled={isOrgProfileFeatureEnabled}
                navigate={navigate}
                isAdmin={isAdmin}
                groups={groups}
              />
              {location.pathname !== "/interviews" && (
              <LogOut
                  isJobRoleFeatureEnabled={isJobRoleFeatureEnabled}
                  isOrgProfileFeatureEnabled={isOrgProfileFeatureEnabled}
               navigate={navigate} />
              )}
            </div>
            
            
          </div>
        </div>
      </div>
      {location.pathname === "/admin/jobroles" || location.pathname === "/admin/jobrole" ? (
        <div/>
      ) : ( <div/>
        )}
    </>
  );
}

function CompanyDropdown(props) {
  const { isJobRoleFeatureEnabled, navigate, groups, isAdmin, isOrgProfileFeatureEnabled } = props;
  const [user, setUser] = useState(null);
  const [currentCompany, setCurrentCompany] = useState(null);
  const [companyLists, setCompanyLists] = useState([]);
  const [permission, setPermission] = useState(null);
  const [dropDownSelectionVisible, setDropDownSelectionVisible] = useState(false);
  const [showCompanySelection, setShowCompanySelection] = useState(false)

  useEffect(() => {
    async function getPermissions() {
      const { userId } = await getAuthData() as { userId?: string };
      const user = await getUser(userId); //fails if Intertru admin
      if (!!user) {
        setUser(user);
        if (user?.role) setPermission(user?.role);
      }
    }
    getPermissions();
  }, []);

  useEffect(() => {
    async function setCompanyDefault() {
     if (isAdmin) {
      try{
        await listCompanies().then((companies) => {
          const superAdmin = {company: "Super Admin"};
          const companyCollectionsDefault = [...companies.items, superAdmin];
          setCompanyLists(companyCollectionsDefault);
          setCurrentCompany(superAdmin);
        });
      }
      catch (error) {
        console.error('Error fetching company:', error);
      }
       
    }
    else {
      try{
        await getCompany(groups[0]).then((company) => {
          setCurrentCompany(company);
        });
      }
      catch (error) {
        console.error('Error fetching company:', error);
      }
    
    }
    }
    setCompanyDefault();
  }, [isAdmin, groups, isJobRoleFeatureEnabled, isOrgProfileFeatureEnabled]);

  const cancelCompanySelection = () => {
    setShowCompanySelection(false);
  };

  const companyOptions = [
    {
      label: "Profile",
      onClick: () => {
        if (isAdmin) {
          setShowCompanySelection(true)
        }
        else {
          props.navigate(`/admin/organizationprofile?compName=${currentCompany.company}&compId=${currentCompany.id}`);
        }
        
      },
      hidden: !isOrgProfileFeatureEnabled,
    },
    {
      label: "Roles",
      onClick: () => {
        props.navigate(`/admin/jobroles`);
      },
      hidden: !isJobRoleFeatureEnabled,
    },
    {
      label: "Users",
      onClick: () => {
        props.navigate("/admin/users");
      },
      hidden:
      (user?.id && permission === "interviewer")
    },
    // {
    //   label: "Billing",
    //   onClick: () => {
        
    //   },
    //   hidden:
    //   !(user?.id && permission === "owner")
    // },
    {
      label: "Customers",
      onClick: () => {
        props.navigate("/admin/customers");
      },
      hidden:
        !groups?.includes("Admin"),
    },
    {
      label: "Switch Company",
      onClick: () => {
        // props.navigate("/admin/customers");
      },
      hidden:
        !groups?.includes("Admin"),
    },

  ];

  return(
    <>
      <button style={styles.companyName}
      onClick={() => setDropDownSelectionVisible(!dropDownSelectionVisible)}
    >
      <div className="font-bold text-[#021A24]">{currentCompany?.company}</div>
      {dropDownSelectionVisible && (
          <div
            style={styles.settingOverlay}
            onClick={(e) => {
              e.preventDefault();
              setDropDownSelectionVisible(false);
            }}
          >
            <div style={styles.companyModal}>
              {companyOptions.map((option, i) => {
                const { label, onClick, hidden } = option;
                let optionStyle: CSSProperties = label === "Billing" || label === "Switch Company" ? { ...styles.settingOptionDisabled } : { ...styles.settingOption };
                if (i !== companyOptions.length - 1 && label !== "Billing")
                  optionStyle.borderBottom = "1px solid #f3f3f3";
                if (!hidden)
                  return (
                    <p key={label} style={optionStyle} onClick={onClick}>
                      {label}
                    </p>
                  );
                return null;
              })}
            </div>
          </div>
        )}
    </button>
    {showCompanySelection && (
        <CompanySelection 
          onClose={cancelCompanySelection}
          modalVisible = {showCompanySelection}
        />
    )}
    </>
  )
}

function HeaderLink(props) {
  const { navigate, link, text, selected = false } = props;
  return (
    <div style={{width: 116, alignItems: "center", textAlign: "center"}}>
      <Link style={{fontSize: 16}}
        className={classNames(
          "px-4 py-2 rounded-full text-white text-base font-['Inter'] leading-normal whitespace-nowrap",
          {
            "bg-transparent font-bold": selected,
            "bg-transparent font-medium": !selected,
          },
        )}
        to={link}
      >
        {text}
      </Link>
      <div className="mt-[5px] ml-[8px] h-[9px] flex items-end">
      {selected ? (
        <svg 
          width="96" 
          height="9" 
          viewBox="0 0 96 9" 
          fill="none" 
          className="block"
        >
          <path 
            d="M0 9C0 4.02944 4.02944 0 9 0H87C91.9706 0 96 4.02944 96 9V9H0V9Z" 
            fill="#EC7729"
          />
        </svg>
      ) : <div className="h-[9px] w-[96px]" />}
      </div>
    </div>
  );
}

function LogOut(props) {
  const { isFeatureEnabled } = props;
  const authData = useAuthData({ getUser: true, getAttr: true, getCogGroups: true });
  const { userName, name, userId, groups } = authData ?? { userName: null, name: null, userId: null, groups: null };
  const [modalVisible, setModalVisible] = useState(false);

  const [user, setUser] = useState(null);
  const [displayName, setDisplayName] = useState("");

  useEffect(() => {
    async function getPermissions() {
      let nameDisplay = name ?? userName;
      const user = await getUser(userId); //fails if Intertru admin
      if (!!user) {
        setUser(user);
        nameDisplay = `${user?.firstName} ${user?.lastName}`;
      }
      setDisplayName(nameDisplay);
    }
    if (userId) {
      getPermissions();
    }
  }, [userName, userId]);

  
  const userOptions = [
    {
      label: "User Info",
      onClick: () => {
        props.navigate(`/admin/user?uid=${user?.id}`);
      },
      hidden: groups?.includes("Admin"),
    },
    {
      label: "Log Out",
      onClick: async () => {
        signOut();
        props.navigate("/");
      },
    },
  ];

  if (groups && displayName?.length > 0)
    return (
      <div className="text-white" style={{ fontSize: 24 }}>
        <div
          className="hor-center"
          onClick={() => setModalVisible(!modalVisible)}
        >
          <p className={'text-[#021A24]'} style={styles.firstName}>{displayName}</p>
          {/* <div style={styles.notificationHolder}>
              <div className="notification-icon"></div>
          </div> */}
        </div>
        {modalVisible && (
          <div
            style={styles.settingOverlay}
            onClick={(e) => {
              e.preventDefault();
              setModalVisible(false);
            }}
          >
            <div style={styles.settingsModal}>
              {userOptions.map((option, i) => {
                const { label, onClick, hidden } = option;
                let optionStyle: CSSProperties = { ...styles.companyOption };
                if (i !== userOptions.length - 1)
                  optionStyle.borderBottom = "1px solid #f3f3f3";
                if (!hidden)
                  return (
                    <p key={label} style={optionStyle} onClick={onClick}>
                      {label}
                    </p>
                  );
                return null;
              })}
            </div>
          </div>
        )}
      </div>
    );
}
